import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import PublicationTemplates from '../../../components/PublicationCreator/PublicationTemplates';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		publicationCreator: {
			fromTemplate: {
				masterTemplatesIds,
				customTemplatesIds,
				loadingStatus,
			},
			isDisplayed,
		},
		driveList: { driveItems },
	} = state;

	return {
		...ownProps,
		masterTemplatesIds,
		customTemplatesIds,
		loadingStatus,
		isDisplayed,
		driveItems,
	};
};

export default connect(mapStateToProps)(PublicationTemplates);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PublicationCreator/PublicationTemplates/index.tsx